// extracted by mini-css-extract-plugin
export default {"soundTracks":"SoundTracks_soundTracks__jj7kh","contentTitle":"SoundTracks_contentTitle__yoLZI","content":"SoundTracks_content__SrECh","backButton":"SoundTracks_backButton__ve9eu"};